import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="jm-container py-28 text-center">
      <p className="font-display text-7xl text-gold">404</p>
      <h1 className="font-display text-4xl text-navy mt-2">Treasure not found</h1>
      <p className="text-ink/60 mt-2">The page you're looking for has wandered off.</p>
      <Link to="/" className="mt-6 inline-block bg-brick text-white font-bold uppercase rounded-md px-6 py-3.5 hover:bg-navy transition-colors">
        Back Home
      </Link>
    </div>
  );
}
